$( document )
.on(`click`, `.quantity__buttons__btn--plus`, function( e ) {
  try {
    e.stopImmediatePropagation();

    const wrapper     =   $( this ).closest( `.quantity__buttons` );
    const getQty      =   wrapper.find( `.quantity__buttons__input` ).val() * 1;
    const maxQty      =   wrapper.find( `.quantity__buttons__input` ).attr( `max` ) * 1;

    if ( getQty < maxQty ) {

      wrapper.find( `.quantity__buttons__input` ).val( `${ getQty + 1 }` );

    }

  }
  catch ( err ) {
    console.log( `ERROR .quantity__buttons__btn--plus`, err.message );
  }
})

.on(`click`, `.quantity__buttons__btn--minus`, function( e ) {
  try {
    e.stopImmediatePropagation();

    const wrapper     =   $( this ).closest( `.quantity__buttons` );
    const getQty      =   wrapper.find( `.quantity__buttons__input` ).val() * 1;

    if ( getQty > 1 ) {

      wrapper.find( `.quantity__buttons__input` ).val( `${ getQty - 1 }` );

    }

  }
  catch ( err ) {
    console.log( `ERROR .quantity__buttons__btn--minus`, err.message );
  }
})

.on(`click`, `.Nutritional-benefits__title`, function( e ) {
  try {
    e.stopImmediatePropagation();

    const wrapper   =   $( this ).closest( `.Nutritional-benefits` );
    const isActive  =   wrapper.hasClass( `active` );

    if ( isActive ) {

      wrapper.removeClass( `active` );

    } else {

      wrapper.addClass( `active` );

    }

  }
  catch ( err ) {
    console.log( `ERROR .Nutritional-benefits__title`, err.message );
  }
})
;

// GALLERY SLIDER START
$( document )
.on(`click`, `.galleryAction`, function( e ) {
  try {
    e.stopImmediatePropagation();

    const getAction    =   $( this ).attr( `action` );

    const getCurrentActive  =   $( `.thumbnails .thumbnails__item.active` ).attr( `slide` ) * 1;
    const isNextAvailable   =   $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive + 1 }"]` ).length;
    const isPrevAvailable   =   $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive - 1 }"]` ).length;
    const totalSlides       =   $( `.thumbnails .thumbnails__item` ).length;

    if ( getAction == 'goNext' ) {

      if ( isNextAvailable > 0 ) {

        const getSrc    =   $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive + 1 }"] img` ).attr( `large-img` );

        $( `.product-header__img > img` ).attr( `src`, getSrc );

        $( `.thumbnails .thumbnails__item` ).removeClass( `active` );

        $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive + 1 }"]` ).addClass( `active` );

      } else {

        const getSrc    =   $( `.thumbnails .thumbnails__item[slide="1"] img` ).attr( `large-img` );

        $( `.product-header__img > img` ).attr( `src`, getSrc );

        $( `.thumbnails .thumbnails__item` ).removeClass( `active` );

        $( `.thumbnails .thumbnails__item[slide="1"]` ).addClass( `active` );

      }

    } else if ( getAction == 'goPrev' ) {

      if ( isPrevAvailable > 0 ) {

        const getSrc    =   $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive - 1 }"] img` ).attr( `large-img` );

        $( `.product-header__img > img` ).attr( `src`, getSrc );

        $( `.thumbnails .thumbnails__item` ).removeClass( `active` );

        $( `.thumbnails .thumbnails__item[slide="${ getCurrentActive - 1 }"]` ).addClass( `active` );

      } else {

        const getSrc    =   $( `.thumbnails .thumbnails__item[slide="${ totalSlides }"] img` ).attr( `large-img` );

        $( `.product-header__img > img` ).attr( `src`, getSrc );

        $( `.thumbnails .thumbnails__item` ).removeClass( `active` );

        $( `.thumbnails .thumbnails__item[slide="${ totalSlides }"]` ).addClass( `active` );

      }

    }

  }
  catch ( err ) {
    console.log( `ERROR .galleryAction`, err.message );
  }
})

.on(`click`, `.thumbnails .thumbnails__item:not(.active)`, function( e ) {
  try {

    e.stopImmediatePropagation();

    const getSrc    =   $( this ).find( `img` ).attr( `large-img` );

    $( `.product-header__img > img` ).attr( `src`, getSrc );

    $( `.thumbnails .thumbnails__item` ).removeClass( `active` );

    $( this ).addClass( `active` );

  }
  catch ( err ) {
    console.log( `ERROR .thumbnails .thumbnails__item:not(.active)`, err.message );
  }
})

;
// GALLERY SLIDER END
